import { replaceAll } from 'core-js/features/string/replace-all';

// eslint-disable-next-line no-extend-native
if (!String.prototype.replaceAll) String.prototype.replaceAll = replaceAll;
